// Utilities
import { mapState, mapGetters } from 'vuex';
import ApiService from '../../services/apiService';
export default {
  name: 'CoreFeedback',
  props: {
    feedbackDialog: {
      type: Boolean,
      required: false,
      default: false
    },
    dialogTitle: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      formValid: false,
      formItem: {},
      bug: '0',
      formData: new FormData(),
      isLoading: false
    };
  },
  computed: {
    ...mapState('app', ['color', 'inpOutlined', 'inpFilled']),
    ...mapGetters({
      user: 'authentication/user',
      tenantId: 'authentication/tenantId'
    }),
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    requiredRule() {
      return [v => !!v || this.$i18n_t('Common.fieldRequired')];
    },
    version() {
      return this.$store.state.app.packageVersion;
    },
    // title() {
    //   if (this.bug === '1') {
    //     return this.$i18n_t('Common.help.bugTitle');
    //   } else {
    //     if (this.type === 'suggestion') {
    //       return this.$i18n_t('Common.help.commitment');
    //     }
    //     return this.$i18n_t('Common.help.shortDescription');
    //   }
    // },
    feedback() {
      if (this.type === 'suggestion') {
        return this.$i18n_t('Common.help.feedbackSuggestion');
      } else if (this.bug === '1') {
        return this.$i18n_t('Common.help.bugDescription');
      } else {
        return this.$i18n_t('Common.help.feedback');
      }
    },
    // description() {
    //   if (this.bug === '1') {
    //     return this.$i18n_t('Common.help.howReproduce');
    //   } else {
    //     if (this.type === 'suggestion') {
    //       return this.$i18n_t('Common.help.needItFor');
    //     }
    //     return this.$i18n_t('Common.help.description');
    //   }
    // },
    placeholder() {
      if (this.type === 'suggestion') {
        return this.$i18n_t('Common.help.placeholderSuggestion');
      }
      return this.$i18n_t('Common.help.placeholder');
    },
    buttons() {
      return [{
        icon: 'fas fa-save',
        title: this.$i18n_t('Common.help.send'),
        type: 'submit'
      }, {
        icon: 'fal fa-times',
        color: 'danger',
        action: 'close',
        tooltip: this.$i18n_t('Common.cancel')
      }];
    }
  },
  watch: {
    feedbackDialog() {
      this.initData();
    }
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      if (this.feedbackDialog) {
        this.formItem['email'] = this.user.email;
        this.formItem['userId'] = this.user.id;
      }
    },
    createFormData() {
      const subject = this.formItem.title ? this.formItem.title : this.$i18n_t('Common.help.customerFeedback');
      this.formData.append('tenantId', this.tenantId);
      this.formData.append('userId', this.formItem.userId);
      this.formData.append('subject', subject);
      this.formData.append('content', this.createBody());
      if (this.bug === '1') {
        this.formData.append('bug', true);
      }
      this.send();
    },
    files(files) {
      this.formData = new FormData();
      if (files.length > 1) {
        files.forEach(file => {
          this.formData.append('attachment', file, file.name);
        });
      } else {
        this.formData.append('file', files[0]);
      }
    },
    close() {
      this.clear();
      this.$emit('close');
    },
    clear() {
      this.formItem = {};
      this.formData = new FormData();
      this.$refs.uploadMultiple.clear();
    },
    createBody() {
      let body = `<h3>${this.dialogTitle}</h3>`;
      if (this.type === 'like') {
        body += this.createDescription(this.formItem.description);
      }
      if (this.type !== 'like') {
        body += this.createDescription(this.formItem.title, this.formItem.description, this.formItem.feedback);
      }
      if (this.formItem.contact) {
        body += `<p>${this.$i18n_t('Common.help.contactMe')}</p>`;
      }
      body += '<hr />';
      body += `<p>${this.$i18n_t('Common.help.emailUser')}: ${this.formItem.email}</p>`;
      body += `<p>${this.$i18n_t('Common.help.userId')}: ${this.formItem.userId}</p>`;
      body += `<p>${this.$i18n_t('Common.help.systemVersion')}: ${this.version}</p>`;
      return body;
    },
    createDescription(text, text2 = null, text3 = null) {
      let content = '';
      if (text2 && text3) {
        content += `<b>${this.$i18n_t('Common.help.titel')}</b></br />`;
        content += `<p>${text}</p></br>`;
        content += `<b>${this.$i18n_t('Common.description')}</b></br>`;
        content += `<p>${text2}</p></br>`;
        content += `<b>${this.$i18n_t('Common.help.detailedDescription')}</b></br>`;
        content += `<p>${text3}</p></br></br>`;
      } else {
        content = `<b>${this.$i18n_t('Common.description')}</b></br>`;
        content += `<p>${text}</p></br></br>`;
      }
      return content;
    },
    send() {
      this.isLoading = true;
      return ApiService.sendFeedback(this.formData).then(() => {
        this.$snack(this.$i18n_t('Common.help.feedbackSendSuccess'), 'success');
        this.$emit('close');
        this.clear();
      }).catch(error => {
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('Common.help.sendingError'), 'error');
        }
        throw error;
      }).finally(() => this.isLoading = false);
    },
    clearFiles() {
      this.formData.delete('attachment');
      this.formData.delete('file');
    }
  }
};